export default () => {
  const { locale } = useI18n();
  const router = useRouter();

  const indexUrl = computed(() => {
    const currentLocalisedSlug = router
      .getRoutes()
      .find(
        (availableRoute) =>
          availableRoute.name ===
          `landingpage-gameserver-slug___${locale.value}`,
      );

    if (currentLocalisedSlug != null) {
      return currentLocalisedSlug.path.replace('/:slug()', '/index');
    }

    return '/en/gameserver/index';
  });

  const homepageUrl = computed(() => `/${locale.value}`);

  return {
    homepageUrl,
    indexUrl,
  };
};
